(function () {
  // FR -> EN runtime translation for the parts of the storefront that Shopify's
  // translation API cannot reach: custom_liquid blocks (order timeline, SGS
  // modal, expert card, features, configurator shell), theme snippets, and
  // third-party widgets (Klaviyo popup, Judge.me). Exact-match phrase
  // dictionary applied to text nodes and a few attributes; only active when
  // <html lang> is "en".
  function isEnglish() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    return lang.indexOf('en') === 0;
  }
  if (!isEnglish()) return;

  var DICT = {
    "Fabrication à la commande": "Made to order",
    "Matériaux haut de gamme": "Premium materials",
    "Contrôle qualité manuel": "Manual quality control",
    "Garantie à vie": "Lifetime warranty",
    "Qualité": "Quality",
    "Contrôle": "Inspection",
    "Garantie": "Warranty",
    "Configurer mon volant": "Configure my steering wheel",
    "Configurer mon cache airbag": "Configure my airbag cover",
    "Contacter par WhatsApp": "Contact via WhatsApp",
    "Nous contacter sur WhatsApp": "Contact us on WhatsApp",
    "Nous contacter": "Contact us",
    "Préparation du configurateur…": "Preparing the configurator…",
    "Valider la configuration": "Confirm configuration",
    "Question précédente": "Previous question",
    "Suivant": "Next",
    "Précédent": "Previous",
    "Fermer": "Close",
    "Ajouter au panier": "Add to cart",
    "Dès": "From",
    "/mois avec": "/month with",
    "Configurateur bientôt disponible": "Configurator coming soon",
    "Sur demande — Nous contacter sur WhatsApp": "On request: contact us on WhatsApp",
    "Sur demande": "On request",
    "Votre navigateur ne supporte pas la balise vidéo.": "Your browser does not support the video tag.",
    "Voir plus de détails": "See more details",
    "Livraison": "Delivery",
    "Fabrication": "Manufacturing",
    "Commandes traitées sous 6 à 10 jours ouvrés (lun–dim). Livraison en France : 2 à 4 jours ouvrés après fabrication.": "Orders are processed within 6 to 10 business days (Mon–Sun). Delivery in France: 2 to 4 business days after manufacturing.",
    "Commandes traitées sous 1 à 2 jours ouvrés (lun–dim). Livraison en France : 2 à 4 jours ouvrés après fabrication.": "Orders are processed within 1 to 2 business days (Mon–Sun). Delivery in France: 2 to 4 business days after manufacturing.",
    "La fabrication des volants personnalisés peut prendre jusqu’à 42 jours selon la configuration sélectionnée.": "Manufacturing of custom steering wheels can take up to 42 days depending on the selected configuration.",
    "Commandé": "Ordered",
    "Volant Fabriqué": "Steering wheel made",
    "Cache Airbag Fabriqué": "Airbag cover made",
    "Livré": "Delivered",
    "En savoir plus +": "Learn more +",
    "Étape 1 · Validation personnalisée": "Step 1 · Personal validation",
    "Parce que chaque détail compte, votre commande déclenche immédiatement un accompagnement personnalisé. Dès cette première étape, un de nos techniciens vous contacte pour confirmer vos choix, valider les spécificités de votre voiture et s'assurer que le résultat sera au-delà de vos attentes.": "Because every detail matters, your order immediately triggers personalized support. From this first step, one of our technicians contacts you to confirm your choices, validate the specifics of your car and make sure the result will exceed your expectations.",
    "Étape 2 · Fabrication sur mesure": "Step 2 · Custom manufacturing",
    "Pendant cette période, votre volant est façonné sur mesure dans notre atelier. Pour vous faire vivre l'expérience de l'intérieur, nous vous envoyons des photos exclusives tout au long de sa production. Sous un mois et demi maximum, votre pièce unique est prête à partir : soigneusement emballée, elle n'attend plus que de métamorphoser votre expérience de conduite.": "During this period, your steering wheel is custom made in our workshop. To let you experience it from the inside, we send you exclusive photos throughout its production. Within a month and a half at most, your one-of-a-kind piece is ready to go: carefully packaged, it only awaits to transform your driving experience.",
    "Pendant cette période, votre cache airbag est façonné sur mesure dans notre atelier. Pour vous faire vivre l'expérience de l'intérieur, nous vous envoyons des photos exclusives tout au long de sa production. Sous une semaine maximum, votre pièce unique est prête à partir : soigneusement emballée, elle n'attend plus que de métamorphoser votre expérience de conduite.": "During this period, your airbag cover is custom made in our workshop. To let you experience it from the inside, we send you exclusive photos throughout its production. Within one week at most, your one-of-a-kind piece is ready to go: carefully packaged, it only awaits to transform your driving experience.",
    "Étape 3 · Livraison & suivi à vie": "Step 3 · Delivery & lifetime support",
    "Étape 2 · Livraison & suivi à vie": "Step 2 · Delivery & lifetime support",
    "Vos palettes arrivent à domicile, mais notre engagement ne s\'arrête pas une fois la pièce installée. Nous vous offrons une garantie à vie sur la structure de votre pièce en carbone, ainsi qu\'un support dédié tout au long de sa durée de vie. Que ce soit pour un conseil d\'entretien ou une simple question, notre équipe de passionnés reste toujours à vos côtés pour garantir une expérience de conduite irréprochable.": "Your paddles arrive at your door, but our commitment does not end once the piece is installed. We offer a lifetime warranty on the structure of your carbon piece, as well as dedicated support throughout its lifetime. Whether it is for maintenance advice or a simple question, our team of enthusiasts is always by your side to guarantee a flawless driving experience.",
    "Votre volant arrive à domicile — mais notre engagement ne s'arrête pas une fois la pièce installée. Nous vous offrons une garantie à vie sur la structure de votre pièce en carbone, ainsi qu'un support dédié tout au long de sa durée de vie. Que ce soit pour un conseil d'entretien ou une simple question, notre équipe de passionnés reste toujours à vos côtés pour garantir une expérience de conduite irréprochable.": "Your steering wheel arrives at your door, but our commitment does not end once the piece is installed. We offer a lifetime warranty on the structure of your carbon piece, as well as dedicated support throughout its lifetime. Whether it is for maintenance advice or a simple question, our team of enthusiasts is always by your side to guarantee a flawless driving experience.",
    "Votre cache airbag arrive à domicile — mais notre engagement ne s'arrête pas une fois la pièce installée. Nous vous offrons une garantie à vie sur la structure de votre pièce en carbone, ainsi qu'un support dédié tout au long de sa durée de vie. Que ce soit pour un conseil d'entretien ou une simple question, notre équipe de passionnés reste toujours à vos côtés pour garantir une expérience de conduite irréprochable.": "Your airbag cover arrives at your door, but our commitment does not end once the piece is installed. We offer a lifetime warranty on the structure of your carbon piece, as well as dedicated support throughout its lifetime. Whether it is for maintenance advice or a simple question, our team of enthusiasts is always by your side to guarantee a flawless driving experience.",
    "ATELIER OEM+ · EXPERT CARBONE": "ATELIER OEM+ · CARBON EXPERT",
    "En ligne": "Online",
    "Configuration sur-mesure": "Custom configuration",
    "Réponse rapide": "Quick reply",
    "Réponse rapide →": "Quick reply →",
    "Un doute sur une compatibilité, une question sur une option ?": "Unsure about compatibility or have a question about an option?",
    "Nous sommes disponibles par écrit sur WhatsApp !": "We are available in writing on WhatsApp!",
    "Mail copié !": "Email copied!",
    "Email": "Email",
    "Erreur lors de la copie du mail :": "Error copying the email:",
    "Certifié SGS": "SGS Certified",
    "Organisme de certification n°1 mondial · 140 pays": "World's number 1 certification body · 140 countries",
    "Carbone Prepreg": "Prepreg Carbon",
    "CARBONE PREPREG": "PREPREG CARBON",
    "Résine époxy pré-imprégnée, zéro bulle d'air": "Pre-impregnated epoxy resin, zero air bubbles",
    "Grade compétition & aérospatiale": "Competition & aerospace grade",
    "Jusqu'à -50%": "Up to -50%",
    "Plus léger que le volant d'origine": "Lighter than the original steering wheel",
    "Vernis Anti-UV": "Anti-UV Clear Coat",
    "Bi-composant longue durée": "Long-lasting two-component",
    "Procédé de fabrication premium": "Premium manufacturing process",
    "Le carbone prepreg est la technologie utilisée en Formule 1, en aérospatiale et dans les supercars. La résine époxy est pré-imprégnée directement dans les fibres avant cuisson sous vide à 130°C — garantissant une densité parfaite et zéro défaut structurel.": "Prepreg carbon is the technology used in Formula 1, aerospace and supercars. The epoxy resin is pre-impregnated directly into the fibers before vacuum curing at 130°C, guaranteeing perfect density and zero structural defects.",
    "Technologie": "Technology",
    "Résine": "Resin",
    "Bulles d'air": "Air bubbles",
    "Résistance": "Strength",
    "Prix": "Price",
    "Pré-imprégnée": "Pre-impregnated",
    "Zéro": "Zero",
    "Maximale": "Maximum",
    "Carbone sec": "Dry carbon",
    "Aucune (infusé)": "None (infused)",
    "Variables": "Variable",
    "Bonne": "Good",
    "Moyen": "Medium",
    "Carbone humide": "Wet carbon",
    "Appliquée à la main": "Applied by hand",
    "Présentes": "Present",
    "Moyenne": "Average",
    "Bas": "Low",
    "Tissage et grade de fibre": "Weave and fiber grade",
    "Le \"3K\" désigne le nombre de filaments par faisceau (3 000 fibres). Le \"Twill\" (sergé) est le motif diagonal emblématique du carbone. Ce grade est utilisé en compétition automobile et en aérospatiale pour son rapport rigidité/poids optimal.": "The \"3K\" refers to the number of filaments per bundle (3,000 fibers). The \"Twill\" is the iconic diagonal weave of carbon. This grade is used in motorsport and aerospace for its optimal stiffness-to-weight ratio.",
    "Grade": "Grade",
    "Filaments": "Filaments",
    "Usage": "Use",
    "Rigidité": "Stiffness",
    "F1 / Aéro": "F1 / Aerospace",
    "Élevée": "High",
    "Industrie": "Industry",
    "Carbone décoratif": "Decorative carbon",
    "Film plastique": "Plastic film",
    "Covering": "Wrap",
    "Aucune": "None",
    "Aucun vernis": "No clear coat",
    "Non": "No",
    "Jusqu'à -50% de masse": "Up to -50% weight",
    "-40 à -50%": "-40 to -50%",
    "Comparatif poids volant": "Steering wheel weight comparison",
    "Réduire la masse du volant améliore directement la précision de direction, réduit l'inertie en virage et allège la fatigue sur long trajet. La différence est perceptible dès la première prise en main.": "Reducing the weight of the steering wheel directly improves steering precision, reduces inertia in corners and eases fatigue on long trips. The difference is noticeable from the first grip.",
    "Type de volant": "Steering wheel type",
    "Poids estimé": "Estimated weight",
    "Réduction": "Reduction",
    "Ressenti": "Feel",
    "Volant carbone": "Carbon steering wheel",
    "Direct et précis": "Direct and precise",
    "Volant sport cuir": "Leather sport steering wheel",
    "Amélioré": "Improved",
    "Volant d'origine (OEM)": "Original steering wheel (OEM)",
    "Lourd": "Heavy",
    "Protection longue durée du carbone": "Long-term carbon protection",
    "Sans protection UV, les fibres de carbone jaunissent en 12 à 24 mois sous la chaleur de l'habitacle. Notre vernis bi-composant est le même standard utilisé en carrosserie automobile haut de gamme — résistant aux UV, aux rayures et aux produits nettoyants.": "Without UV protection, carbon fibers turn yellow within 12 to 24 months under the heat of the cabin. Our two-component clear coat is the same standard used in high-end automotive bodywork, resistant to UV, scratches and cleaning products.",
    "Type de finition": "Finish type",
    "Résistance UV": "UV resistance",
    "Anti-rayures": "Scratch resistance",
    "Durée de vie": "Lifespan",
    "Vernis Anti-UV Bi-composant": "Two-Component Anti-UV Clear Coat",
    "Renforcée": "Reinforced",
    "Vernis 2K bi-composant": "2K two-component clear coat",
    "Totale": "Full",
    "5 ans+": "5+ years",
    "Vernis 1K mono-composant": "1K single-component clear coat",
    "Partielle": "Partial",
    "Limitée": "Limited",
    "1 – 2 ans": "1 to 2 years",
    "6 – 12 mois": "6 to 12 months",
    "Comparatif des technologies": "Technology comparison",
    "Les lignes en bleu correspondent à la technologie utilisée sur vos volants Atelier OEM+.": "The rows in blue correspond to the technology used on your Atelier OEM+ steering wheels.",
    "Certification SGS": "SGS Certification",
    "Tests indépendants internationaux": "Independent international tests",
    "SGS est l'organisme de contrôle qualité et de certification": "SGS is the quality control and certification body",
    "n°1 mondial": "number 1 worldwide",
    ", présent dans plus de": ", present in more than",
    "140 pays": "140 countries",
    ". Chaque volant Atelier OEM+ est soumis à des tests indépendants effectués par SGS avant sa commercialisation.": ". Every Atelier OEM+ steering wheel undergoes independent tests carried out by SGS before it goes on sale.",
    "Tests structurels": "Structural tests",
    "Résistance mécanique, tenue à la contrainte et intégrité des matériaux vérifiées sur chaque modèle.": "Mechanical strength, stress resistance and material integrity verified on every model.",
    "Conformité des matériaux": "Material compliance",
    "Contrôle des substances utilisées (résine époxy, fibres, finitions) pour garantir leur conformité aux normes automobiles.": "Control of the substances used (epoxy resin, fibers, finishes) to guarantee their compliance with automotive standards.",
    "Tests indépendants": "Independent tests",
    "Les tests sont réalisés par SGS, tiers indépendant — pas par le fabricant. Résultats objectifs et vérifiables.": "The tests are carried out by SGS, an independent third party, not by the manufacturer. Objective, verifiable results.",
    "Référence mondiale": "Global reference",
    "SGS est reconnue par les industries automobile, aérospatiale et pharmaceutique. La même référence utilisée par les équipementiers OEM.": "SGS is recognized by the automotive, aerospace and pharmaceutical industries. The same reference used by OEM suppliers.",
    "Sur-mesure": "Custom",
    "Satisfait ou remboursé": "Satisfied or refunded",
    "Inscrivez-vous": "Sign up",
    "Rejoignez votre newsletter et bénéficiez de 150€ de réductions sur votre première commande !": "Join our newsletter and get €150 off your first order!",
    "Téléphone": "Phone",
    "Numéro de téléphone": "Phone number",
    "OBLIGATOIRE": "REQUIRED",
    "Cochez cette case pour recevoir également des messages marketing promotionnels (offres et codes de réduction exclusifs uniquement proposés via WhatsApp).": "Check this box to also receive promotional marketing messages (exclusive offers and discount codes offered only via WhatsApp).",
    "Obtenir le code": "Get the code",
    "En envoyant ce formulaire, vous acceptez de recevoir des messages informatifs (par exemple, un suivi de commande) et/ou marketing (par exemple, un rappel de panier) de la part de L'Atelier OEM +, y compris des messages envoyés par un système automatique. Le consentement n’est pas une condition d’achat. Désabonnez-vous à tout moment en répondant STOP.": "By submitting this form, you agree to receive informational messages (for example, order tracking) and/or marketing messages (for example, a cart reminder) from L'Atelier OEM +, including messages sent by an automated system. Consent is not a condition of purchase. Unsubscribe at any time by replying STOP.",
    "Dans nos ateliers": "In our workshops",
    "Ponçage manuel de la base avant fibre de carbone": "Hand sanding of the base before the carbon fiber",
    "Couture manuelle du cuir perforé, point par point": "Hand stitching of the perforated leather, stitch by stitch",
    "Finition carbone forgé, chaque pièce est unique": "Forged carbon finish, every piece is unique",
    "Choose an option": "Choose an option",
    "Année + Modèle et Personnalisation": "Year + Model and Customization",
    "Carbone sergé ou carbone forgé : quel volant sur mesure choisir ?": "Twill Carbon or Forged Carbon: Which Custom Steering Wheel to Choose?",
    "Volant carbone Audi R8, TT, TTS, TTRS MK3 : quel modèle choisir ?": "Audi R8, TT, TTS, TTRS MK3 Carbon Steering Wheel: Which Model to Choose?",
    "Volant carbone sur mesure et sécurité : le rôle essentiel de la base OEM": "Custom Carbon Steering Wheel and Safety: The Essential Role of the OEM Base",
    "Suivre": "Follow",
    "Previous slide": "Previous slide",
    "Next slide": "Next slide",
    "Product preset title": "Product preset title",
    "Comment évalueriez-vous ce produit ?": "How would you rate this product?",
    "Nous serions ravis que vous partagiez un peu votre expérience.": "We would love it if you shared a bit about your experience.",
    "Contenu de l'avis (Obligatoire)": "Review content (Required)",
    "Nous vous contacterons uniquement au sujet de votre avis si nécessaire. En soumettant votre avis, vous acceptez nos": "We will only contact you about your review if necessary. By submitting your review, you agree to our",
    "conditions d'utilisation": "terms of service",
    "et notre": "and our",
    "politique de confidentialité": "privacy policy",
    "À propos de vous": "About you",
    "Veuillez nous en dire plus sur vous.": "Please tell us more about yourself.",
    "Adresse email (Obligatoire)": "Email address (Required)",
    "Nous respectons votre vie privée.": "We respect your privacy.",
    "Nom d'affichage (Obligatoire)": "Display name (Required)",
    "Ne sera pas visible pour les autres clients.": "Will not be visible to other customers.",
    "Avis anonyme": "Anonymous review",
    "Partager une photo ou une vidéo": "Share a photo or video",
    "Téléchargez une photo ou une vidéo pour étayer votre avis.": "Upload a photo or video to support your review.",
    "Cliquez pour télécharger": "Click to upload",
    "ou glissez-déposez": "or drag and drop",
    "Retour": "Back",
    "Merci pour votre avis !": "Thank you for your review!",
    "Nous le traitons et il apparaîtra bientôt dans la boutique.": "We are processing it and it will appear in the store soon.",
    "Veuillez confirmer votre email en cliquant sur le lien que nous venons de vous envoyer. Cela nous aide à maintenir des avis authentiques.": "Please confirm your email by clicking the link we just sent you. This helps us keep reviews authentic.",
    "Aimeriez-vous partager votre expérience d'achat avec nous ?": "Would you like to share your shopping experience with us?",
    "Nous apprécions votre retour d'expérience et nous l'utilisons pour nous améliorer. Veuillez partager vos pensées ou suggestions.": "We appreciate your feedback and use it to improve. Please share your thoughts or suggestions.",
    "Histoire de clients réels": "Real customer stories",
    "Vérifié": "Verified",
    "Nos clients en parlent mieux que nous": "Our customers say it better than we do",
    "Écrire un avis": "Write a review",
    "Filtres": "Filters",
    "Plus récents": "Most recent",
    "Meilleures notes": "Highest rated",
    "Notes les plus basses": "Lowest rated",
    "Uniquement les photos": "Photos only",
    "Photos en premier": "Photos first",
    "Vidéos en premier": "Videos first",
    "Plus utiles": "Most helpful",
    "Commencez à écrire ici...": "Start writing here...",
    "Votre adresse email": "Your email address",
    "Nom d'affichage": "Display name",
    "Collez votre URL Youtube ici": "Paste your YouTube URL here",
    "Module shift LED en carbone avec écran de régime et de vitesse": "Carbon shift LED module with RPM and speed display",
    "Volant Audi en carbone avec module shift LED installé dans la voiture": "Carbon Audi steering wheel with shift LED module installed in the car"
  };

  // Configurator answers as they appear in cart line-item properties (data
  // stays French on the order; only the display is translated).
  var PHRASES = [
    ["forme du volant", "Steering Wheel Shape"],
    ["type de poignées", "Grip Type"],
    ["poignées en cuir perforé", "Perforated Leather Grips"],
    ["poignées cuir perforé", "Perforated Leather Grips"],
    ["poignées en cuir lisse", "Smooth Leather Grips"],
    ["poignées cuir lisse", "Smooth Leather Grips"],
    ["poignées en alcantara", "Alcantara Grips"],
    ["poignées alcantara", "Alcantara Grips"],
    ["type d'insert", "Insert Type"],
    ["insert en cuir lisse", "Smooth Leather Insert"],
    ["insert cuir lisse", "Smooth Leather Insert"],
    ["insert cuir", "Leather Insert"],
    ["insert en alcantara", "Alcantara Insert"],
    ["insert alcantara", "Alcantara Insert"],
    ["insert en carbone", "Carbon Insert"],
    ["insert carbone", "Carbon Insert"],
    ["insert en carbone forgé", "Forged Carbon Insert"],
    ["insert carbone forgé", "Forged Carbon Insert"],
    ["couleur des surpiqures (pas visible sur le configurateur)", "Stitching Color (not shown in configurator)"],
    ["couleur des surpiqures", "Stitching Color"],
    ["couleur des surpiqures du cache airbag", "Airbag Cover Stitching Color"],
    ["rappel 12h", "12 O'Clock Marker"],
    ["personnaliser le cache airbag ?", "Customize the airbag cover?"],
    ["matière cache airbag", "Airbag Cover Material"],
    ["shiftled", "ShiftLed"],
    ["boîte automatique?", "Automatic Transmission?"],
    ["palettes txcp", "TXCP Paddles"],
    ["couleur palettes carbone", "Carbon Paddle Color"],
    ["couleur palettes carbone allegee", "Lightweight Carbon Paddle Color"],
    ["couleur palettes allegee", "Lightweight Carbon Paddle Color"],
    ["couleur palettes carbone forgé", "Forged Carbon Paddle Color"],
    ["avez-vous l'option volant chauffant?", "Does your car have the Heated Steering Wheel option?"],
    ["ajout du pack volant complet (commande au volant, électronique de palette, airbag complet)", "Add the Full Steering Wheel Pack (steering wheel controls, paddle electronics, complete airbag)"],
    ["ajout du pack volant complet (électronique de palette, airbag complet)", "Add the Full Steering Wheel Pack (paddle electronics, complete airbag)"],
    ["modèle du véhicule et indiquez vos préférences de configuration (surpiqûres, couleur du rappel 12:00, style de carbone,etc.). nous en tiendrons compte lors de la fabrication.", "Vehicle model and your configuration preferences (stitching, 12 o'clock marker color, carbon style, etc.). We will take this into account during manufacturing."],
    ["envoyez une photo de votre volant actuel", "Send a photo of your current steering wheel"],
    ["personnaliser le contour des boutons ?", "Customize the button trim?"],
    ["contours des boutons", "Button Trim"],
    ["logo", "Logo"],
    ["couleur des lettres du logo", "Logo Letters Color"],
    ["couleur logo", "Logo Color"],
    ["bouton style r8", "R8-Style Button"],
    ["logo insert", "Logo Insert"],
    ["garniture supplémentaire", "Additional Trim"],
    ["garnitures supplémentaires", "Additional Trims"],
    ["coutures cache airbag", "Airbag Cover Stitching"],
    ["personnaliser la garniture centrale", "Customize the center trim?"],
    ["personnaliser les garnitures ?", "Customize the trims?"],
    ["couleur garnitures", "Trim Color"],
    ["matière garniture centrale", "Center Trim Material"],
    ["votre véhicule a t'il l'option line assist ? (volant vibrant) ou volant chauffant?", "Does your car have the Line Assist option (vibrating wheel) or Heated Steering Wheel?"],
    ["ronde", "Round"],
    ["méplat", "Flat-Bottom"],
    ["sportive", "Sport"]
  ];

  var KF_EN_MATERIALS = [
    ["carbone noir nid d'abeilles", "Black Honeycomb Carbon"], ["nid d'abeilles", "Honeycomb"],
    ["carbone forgé", "Forged Carbon"], ["carbon forgé", "Forged Carbon"], ["carbone forge", "Forged Carbon"],
    ["carbone allégé", "Lightweight Carbon"], ["carbone allege", "Lightweight Carbon"],
    ["fibre sergée", "Twill Carbon"], ["fibre sergé", "Twill Carbon"],
    ["cuir perforé", "Perforated Leather"], ["cuir perfore", "Perforated Leather"], ["cuir lisse", "Smooth Leather"], ["cuir surpiqué", "Stitched Leather"],
    ["forgé", "Forged"], ["forge", "Forged"],
    ["carbone", "Carbon"], ["carbon", "Carbon"], ["caborne", "Carbon"],
    ["alcantara", "Alcantara"], ["cuir", "Leather"], ["aluminium", "Aluminum"]
  ];
  var KF_EN_COLORS = [
    ["bleu ciel", "Sky Blue"], ["noir brillant", "Gloss Black"], ["noire brillante", "Gloss Black"],
    ["noir matte", "Matte Black"], ["noir mat", "Matte Black"], ["noire mat", "Matte Black"],
    ["rouge mat", "Matte Red"], ["argenté mat", "Matte Silver"],
    ["noire", "Black"], ["noir", "Black"], ["blanche", "White"], ["blanc", "White"],
    ["bleu", "Blue"], ["rouge", "Red"], ["verte", "Green"], ["vert", "Green"],
    ["jaune", "Yellow"], ["rose", "Pink"], ["violet", "Purple"], ["grise", "Gray"], ["gris", "Gray"],
    ["marron", "Brown"], ["beige", "Beige"], ["orange", "Orange"], ["bordeaux", "Burgundy"],
    ["argenté", "Silver"], ["argent", "Silver"], ["doré", "Gold"], ["or", "Gold"],
    ["matte", "Matte"], ["mat", "Matte"], ["brillant", "Glossy"]
  ];
  var KF_EN_MISC = {
    'oui': 'Yes', 'non': 'No', 'avec': 'With', 'sans': 'Without', 'aucun': 'None', 'aucune': 'None',
    'allemagne': 'Germany', 'untitled answer': 'Untitled answer', 'volant chauffant': 'Heated Steering Wheel', 'm performance': 'M Performance',
    's-line': 'S-Line', 'r-line': 'R-Line', 'line assist': 'Line Assist',
    's-line noir': 'S-Line Black', 'r32 noir': 'R32 Black', 'gti noir': 'GTI Black', 'gti rouge': 'GTI Red', 'rs noir': 'RS Black', 's noir': 'S Black'
  };
  function kfEnAnswer(text) {
    var t = text.trim().replace(/\s+/g, ' ').replace(/al+[eé]g[eé]e?/gi, 'allégé');
    if (!t) return null;
    var low = t.toLowerCase();
    if (KF_EN_MISC.hasOwnProperty(low)) return KF_EN_MISC[low];
    // Connectors ("noir et rouge", "avec ...") keep their order: leave them to the caller's word-by-word fallback.
    if (/(^| )(et|avec|sans)( |$)/.test(low)) return null;
    var upper = t.length > 1 && t === t.toUpperCase() && t !== t.toLowerCase();
    var rest = low, mat = null, cols = [], others = [], changed = false;
    for (var i = 0; i < KF_EN_MATERIALS.length; i++) {
      var m = KF_EN_MATERIALS[i];
      if (rest === m[0] || rest.indexOf(m[0] + ' ') === 0) {
        mat = m[1]; rest = rest.slice(m[0].length).trim(); changed = true; break;
      }
    }
    while (rest) {
      var hit = null;
      for (var j = 0; j < KF_EN_COLORS.length; j++) {
        var c = KF_EN_COLORS[j];
        if (rest === c[0] || rest.indexOf(c[0] + ' ') === 0) { hit = c; break; }
      }
      if (hit) {
        cols.push(hit[1]); rest = rest.slice(hit[0].length).trim(); changed = true;
      } else {
        var sp = rest.indexOf(' ');
        var tok = sp === -1 ? rest : rest.slice(0, sp);
        others.push(t.slice(t.length - rest.length, t.length - rest.length + tok.length));
        rest = sp === -1 ? '' : rest.slice(sp + 1).trim();
      }
    }
    if (!changed) return null;
    var res = cols.concat(mat ? [mat] : [], others).join(' ');
    if (upper) return res.toUpperCase();
    return res.charAt(0).toUpperCase() + res.slice(1);
  }

  var MONTHS = { 'Jan': 'Jan', 'Fév': 'Feb', 'Mar': 'Mar', 'Avr': 'Apr', 'Mai': 'May', 'Jun': 'Jun', 'Jul': 'Jul', 'Aoû': 'Aug', 'Sep': 'Sep', 'Oct': 'Oct', 'Nov': 'Nov', 'Déc': 'Dec' };

  var WHATSAPP_TEXTS = [
    [/^Bonjour,\s*Je serais intéressé pour un volant personnalisé voici ma configuration\s*:?$/i, 'Hello,\n\nI would be interested in a custom steering wheel, here is my configuration:'],
    [/^Bonjour,\s*Je serais intéressé pour un cache airbag personnalisé voici ma configuration\s*:?$/i, 'Hello,\n\nI would be interested in a custom airbag cover, here is my configuration:'],
    [/^Bonjour,\s*Je suis intéressé par le volant (.+) et je souhaite une commande sur devis$/i, 'Hello,\n\nI am interested in the $1 steering wheel and would like to order by quote'],
    [/^Bonjour,\s*Je suis intéressé par le volant (.+) et j'aurais une question$/i, 'Hello,\n\nI am interested in the $1 steering wheel and I have a question']
  ];

  function normalize(s) {
    return s
      .replace(/[‘’ʼ]/g, "'")
      .replace(/[\xa0\u2000-\u200b\u202f]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }
  var DICT_NORM = {};
  Object.keys(DICT).forEach(function (k) { DICT_NORM[normalize(k)] = DICT[k]; });

  var PHRASE_NORM = {};
  PHRASES.forEach(function (p) { PHRASE_NORM[normalize(p[0]).replace(/\s+\?/g, '?')] = p[1]; });

  // Cart line-item property keys/values (French data) -> English display text.
  var PROP_KEYS = {
    'forme': 'Shape', 'poignées': 'Grips', 'poignees': 'Grips', 'insert': 'Insert', 'palettes': 'Paddles', 'palettes txcp': 'TXCP Paddles',
    'surpiqures': 'Stitching', 'surpiqûres': 'Stitching', 'rappel 12h': "12 O'Clock Marker", 'cache airbag': 'Airbag Cover',
    'matière cache airbag': 'Airbag Cover Material', 'coutures cache airbag': 'Airbag Cover Stitching',
    'contours des boutons': 'Button Trim', 'garniture': 'Trim', 'garnitures': 'Trims', 'logo': 'Logo',
    'shiftled': 'ShiftLed', 'boîte automatique?': 'Automatic Transmission?', 'palettes carbone': 'Carbon Paddles',
    'palettes carbone forgé': 'Forged Carbon Paddles', 'palettes carbone allégé': 'Lightweight Carbon Paddles'
  };
  function translateProp(text) {
    var trimmed = text.trim().replace(/\s+/g, ' ');
    if (!trimmed) return null;
    var m = trimmed.match(/^(.*?)(\s*\(\+[^)]*\))?$/);
    var core = m[1], tail = m[2] || '', colon = '';
    var mc = core.match(/^(.*?)\s*:$/);
    if (mc) { core = mc[1]; colon = ':'; }
    var key = normalize(core).replace(/\s+\?/g, '?').replace(/al+[eé]g[eé]e?/g, 'allégé');
    var out;
    if (PROP_KEYS.hasOwnProperty(key)) out = PROP_KEYS[key];
    else if (PHRASE_NORM.hasOwnProperty(key.replace(/allégé/g, 'allege'))) out = PHRASE_NORM[key.replace(/allégé/g, 'allege')];
    else {
      out = kfEnAnswer(core);
      if (out === null) return null;
    }
    return out + colon + tail;
  }

  function translateString(trimmed) {
    var key = normalize(trimmed);
    if (DICT_NORM.hasOwnProperty(key)) return DICT_NORM[key];
    var m;
    // "Dès 63,00€/mois avec" -> "From 63,00€/month with"
    if ((m = trimmed.match(/^Dès\s+(.+?)\s*\/\s*mois avec$/i))) return 'From ' + m[1] + '/month with';
    // "À partir de 599,99€" -> "From 599,99€"
    if ((m = trimmed.match(/^À partir de\s+(.+)$/i))) return 'From ' + m[1];
    // Judge.me / app-rendered product names still carrying the French catalogue title
    if ((m = trimmed.match(/^Volant Carbone Sur-Mesure OEM\b(.*)$/i))) return 'Custom Carbon Steering Wheel OEM' + m[1];
    if ((m = trimmed.match(/^Volant en Carbone Personnalisé pour Modèles\b(.*)$/i))) return 'Custom Carbon Steering Wheel for' + m[1] + ' Models';
    // Judge.me widget counters and accessibility strings
    if ((m = trimmed.match(/^([\d.,]+) sur 5 étoiles basé sur (\d+) avis$/))) return m[1].replace(',', '.') + ' out of 5 stars based on ' + m[2] + ' reviews';
    if ((m = trimmed.match(/^(\d(?:[.,]\d)?) sur 5$/))) return m[1].replace(',', '.') + ' out of 5';
    if ((m = trimmed.match(/^(\d+) avis$/))) return m[1] + (m[1] === '1' ? ' review' : ' reviews');
    // Collection/brand image alts: "Volant Audi sur mesure — Carbone & Alcantara | Atelier OEM+"
    if ((m = trimmed.match(/^Volant (.+?) sur mesure\s+[—–-]\s+(.+?) \| Atelier OEM\+$/))) {
      return 'Custom ' + m[1] + ' Steering Wheel: ' + m[2].replace(/Carbone/g, 'Carbon').replace(/Série/g, 'Series') + ' | Atelier OEM+';
    }
    // "12 Fév" or "12 Fév - 25 Mar" (timeline dates)
    if (/^\d{1,2}\s+(Jan|Fév|Mar|Avr|Mai|Jun|Jul|Aoû|Sep|Oct|Nov|Déc)\b/.test(trimmed) && /^[\d\sA-Za-zéû\-–—→]+$/.test(trimmed)) {
      return trimmed.replace(/\b(Jan|Fév|Mar|Avr|Mai|Jun|Jul|Aoû|Sep|Oct|Nov|Déc)\b/g, function (x) { return MONTHS[x]; });
    }
    return null;
  }

  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEMPLATE: 1, TEXTAREA: 1, CODE: 1, PRE: 1 };
  function skipped(el) {
    for (var n = el; n && n.nodeType === 1; n = n.parentElement) {
      if (SKIP_TAGS[n.tagName]) return true;
      if (n.getAttribute && (n.getAttribute('translate') === 'no' || (n.classList && (n.classList.contains('notranslate') || n.classList.contains('jdgm-rev__body') || n.classList.contains('jdgm-rev__title'))))) return true;
    }
    return false;
  }
  function isPropNode(el) {
    return !!(el && el.closest && el.closest('[class*="cart-item-drawer__option"], [class*="cart-item__option"], [class*="cart-item__propert"], [class*="line-item-propert"], dl.product-details, .product-details, .cart-item__details dd, .cart-item__details dt'));
  }

  function translateTextNode(node) {
    var text = node.nodeValue;
    if (!text || !text.trim()) return;
    var trimmed = text.trim();
    var el = node.parentElement;
    if (!el || skipped(el)) return;
    var out = translateString(trimmed);
    if (out === null && isPropNode(el)) out = translateProp(trimmed);
    if (out !== null && out !== trimmed) node.nodeValue = text.replace(trimmed, out);
  }

  var ATTRS = ['aria-label', 'title', 'placeholder', 'alt'];
  function translateAttrs(el) {
    if (skipped(el)) return;
    for (var i = 0; i < ATTRS.length; i++) {
      var v = el.getAttribute(ATTRS[i]);
      if (!v || !v.trim()) continue;
      var out = translateString(v.trim());
      if (out !== null && out !== v.trim()) el.setAttribute(ATTRS[i], out);
    }
    if (el.tagName === 'A') translateWhatsapp(el);
  }

  function translateWhatsapp(a) {
    var href = a.getAttribute('href');
    if (!href || href.indexOf('whatsapp.com/send') === -1 && href.indexOf('wa.me') === -1) return;
    try {
      var u = new URL(href, location.href);
      var t = u.searchParams.get('text');
      if (!t) return;
      for (var i = 0; i < WHATSAPP_TEXTS.length; i++) {
        if (WHATSAPP_TEXTS[i][0].test(t.replace(/\s+/g, ' ').trim())) {
          u.searchParams.set('text', t.replace(/\s+/g, ' ').trim().replace(WHATSAPP_TEXTS[i][0], WHATSAPP_TEXTS[i][1]));
          a.setAttribute('href', u.toString());
          return;
        }
      }
    } catch (e) { /* malformed URL: leave as is */ }
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { translateTextNode(root); return; }
    if (root.nodeType !== 1 || SKIP_TAGS[root.tagName]) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) translateTextNode(node);
    if (root.matches && root.matches('[aria-label],[title],[placeholder],[alt],a[href*="whatsapp"],a[href*="wa.me"]')) translateAttrs(root);
    root.querySelectorAll('[aria-label],[title],[placeholder],[alt],a[href*="whatsapp"],a[href*="wa.me"]').forEach(translateAttrs);
  }

  var pending = [];
  var scheduled = false;
  function flush() {
    scheduled = false;
    var batch = pending; pending = [];
    for (var i = 0; i < batch.length; i++) walk(batch[i]);
  }
  function queue(node) {
    pending.push(node);
    if (!scheduled) { scheduled = true; Promise.resolve().then(flush); }
  }

  function run() { walk(document.body); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'childList') {
        for (var j = 0; j < m.addedNodes.length; j++) queue(m.addedNodes[j]);
      } else if (m.type === 'characterData') {
        queue(m.target);
      } else if (m.type === 'attributes' && m.target.nodeType === 1) {
        queue(m.target);
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'title', 'placeholder', 'alt'] });
})();
